import React, {Component} from 'react';

class ArticleTableCell extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        let {
            ColumnType
        } = this.props.cell;
        return (
            <td>
                {ColumnType.Value ? (
                    <span>{this.props.text}</span>
                ) :(
                    <span>&nbsp;</span>
                )}
  
            </td>
        )
    }
}

export default ArticleTableCell;